import { render, staticRenderFns } from "./DivisionList.vue?vue&type=template&id=1f0e53de&"
import script from "./DivisionList.vue?vue&type=script&lang=js&"
export * from "./DivisionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports